import htmx from 'htmx.org';

export default class ActiveFilters {

    constructor(element) {
        this.element = element;
        const filters = this.element.querySelectorAll('.c-active-filters__filter');

        for (const filter of filters) {
            const button = filter.querySelector('.c-active-filters__remove');
            const facet = filter.dataset.facet;
            const value = filter.dataset.facetOption;
            button.addEventListener('click', () => {
                this.removeFilter(facet, value);
                filter.style.width = 0;
                filter.style.margin = 0;
                filter.style.textWrap = 'nowrap';
                filter.style.overflow = 'hidden';
            });
        }
    }

    removeFilter(facet, value) {
        const name = `${facet}[]`;
        const input = document.querySelector(`input[type=checkbox][name="${name}"][value="${value}"]`);

        // Uncheck the checkbox
        input.checked = false;

        // Trigger form submit event to refetch search results
        htmx.trigger(input.form, 'submit');
    }

}
